<template>
  <div>
    <ml-header
      :title="
        id === vipId ? 'VIP充值秘书' : id === serviceId ? '在线咨询客服' : id
      "
      background-color="#fff"
      :dark="true"
    />
    <div class="chat-page">
      <Purchase
        v-if="isPurchaseVip"
        @click-combo="selectCombo"
        class="purchase"
      />
      <Sell v-if="isService" @click-combo="topUpCombo" class="purchase" />
      <template v-for="(conversation, index) in conversations">
        <ChatPanel
          v-if="conversation.from_username === id"
          :messages="conversation.msgs"
          :key="index"
        />
      </template>
    </div>
    <div
      class="chat-message-input"
      :style="{ marginBottom: isIphoneX ? '20px' : '0' }"
    >
      <div class="image-input-wrapper" @click="handleUpload">
        <img src="../../assets/message/image@.png" alt="" />
        <input ref="imageUploadRef" type="file" @change="handleSelectedImage" />
      </div>
      <div class="input-wrapper">
        <input v-model="inputMsg" type="text" placeholder="输入内容" />
      </div>
      <button
        :class="{ active: inputMsg.length > 0 }"
        @click="handleSendMessage"
      >
        发送
      </button>
    </div>
    <img
      class="shot-sentence-button"
      src="../../assets/message/sentence@2x.png"
      alt=""
      @click="openShortSentence = true"
    />
    <div
      class="shot-sentence-wrapper"
      v-if="openShortSentence"
      @click="handleCloseShortSentence"
    >
      <ul class="shot-sentence">
        <li
          v-for="(sentence, index) in sentences"
          :key="index"
          @click="handleClickSentence(index)"
        >
          <p>{{ sentence }}</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import ChatPanel from "./components/ChatPanel/index";
import Purchase from "./components/Purchase";
import { getCustomerSentence, getServiceSentence } from "@/api/shortSentence";
import { mapState, mapActions } from "vuex";
import Sell from "@/views/message/components/Sell";
import { topUpVip } from "@/api/vip";
import { getImageFormData } from "@/utils/upload";
import { isIphoneX } from "@/utils/isIphoneX";

export default {
  name: "Chat",
  components: {
    Sell,
    ChatPanel,
    Purchase
  },
  computed: {
    ...mapState("user", ["nickname", "phone"]),
    ...mapState("chat", ["conversations"]),
    ...mapState("platform", ["vipId", "serviceId"]),
    isPurchaseVip() {
      return this.id === this.vipId;
    },
    isService() {
      return this.phone === this.vipId;
    }
  },
  data() {
    return {
      id: this.$route.params.id,
      messages: [],
      inputMsg: "",
      sentences: [],
      openShortSentence: false,
      isIphoneX: isIphoneX()
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    ...mapActions("chat", ["sendSingleMsg", "sendSinglePic"]),
    async fetchData() {
      if (this.isService) {
        this.sentences = await getServiceSentence();
      } else {
        this.sentences = await getCustomerSentence();
      }
    },
    async handleClickSentence(index) {
      this.inputMsg = this.sentences[index];
      await this.handleSendMessage();
      this.openShortSentence = false;
    },
    async topUpCombo(text) {
      try {
        await topUpVip("18566945540", text);
        await this.sendSingleMsg({
          targetUsername: this.id,
          // TODO:检测到这几个字符串，dispatch("getUserInfo")，重新拉取用户信息
          content: `${text}套餐充值成功！`
        });
        this.inputMsg = "";
      } catch (e) {
        this.$toast(`为${18566945540}用户充值${text}失败`);
      }
    },
    async selectCombo(text) {
      await this.sendSingleMsg({
        targetUsername: this.id,
        content: `我要买${text}`
      });
      this.inputMsg = "";
    },
    async handleSendMessage() {
      await this.sendSingleMsg({
        targetUsername: this.id,
        content: this.inputMsg
      });
      this.inputMsg = "";
    },
    handleUpload() {
      this.$refs["imageUploadRef"].click();
    },
    async handleSelectedImage() {
      await this.sendSinglePic({
        targetUsername: this.id,
        file: getImageFormData(this.$refs["imageUploadRef"])
      });
    },
    handleCloseShortSentence(event) {
      if (event.target.className === "shot-sentence-wrapper") {
        this.openShortSentence = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.chat-page {
  display: flex;
  flex-direction: column;
  padding: 40px 0 50px 0;
  height: 100vh;
  overflow: hidden;
  .purchase {
    margin: 0 15px;
  }
}

.chat-message-input {
  position: fixed;
  bottom: 0;
  display: flex;
  align-items: center;
  width: 100%;
  height: 50px;
  background: rgba(255, 255, 255, 1);
  .image-input-wrapper {
    margin: 0 15px;
    width: 25px;
    height: 25px;
    > img {
      width: 100%;
      height: 100%;
    }
    > input {
      display: none;
      position: absolute;
      z-index: 999;
      width: 100%;
      height: 100%;
    }
  }
  .input-wrapper {
    flex: 1;
    padding: 0 10px;
    width: 240px;
    height: 34px;
    border-radius: 18px;
    background: #f6f6f6;
    > input {
      width: 100%;
      height: 100%;
      font-size: 14px;
      color: #000;
      line-height: 20px;
      background: transparent;
    }
    > input::placeholder {
      font-weight: 400;
      color: rgba(180, 180, 180, 1);
    }
  }
  > button {
    margin: 0 10px;
    border: none;
    width: 58px;
    height: 34px;
    background: rgba(211, 210, 210, 1);
    border-radius: 28px;
    font-size: 14px;
    font-weight: 500;
    color: rgba(255, 255, 255, 1);
    line-height: 20px;
    transition: all 0.5s ease 0s;
  }
  .active {
    background: rgba(253, 215, 0, 1);
    color: rgba(51, 51, 51, 1);
  }
}
.shot-sentence-button {
  position: fixed;
  width: 74px;
  height: 74px;
  bottom: 60px;
  right: 10px;
}
.shot-sentence-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  text-align: left;
  .shot-sentence {
    padding: 23px 15px;
    width: 100%;
    bottom: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    background-color: #fff;
    border-radius: 12px 12px 0 0;
    li {
      width: 100%;
      padding: 15px 0;
      border-bottom: 1px solid rgba(230, 230, 230, 1);
      p {
        font-size: 15px;
        color: rgba(51, 51, 51, 1);
        line-height: 20px;
      }
    }
  }
}
</style>
